import { Box, IconButton, Typography } from "@mui/material"
import CustomAccordion from "../../../../../../components/accordion"
import { useStyles } from "./styles"
import { Question } from "../question"
import { SectionProps } from "./types"
import { memo, useMemo, useState } from "react"
import { icons } from "../../../../../../utils/icons"
import { assignColor } from "../../../../../../utils/methods/assignColor"
import { useTranslation } from "react-i18next"
import StatusComponent from "../../../../../../components/status"
import { getStatus } from "../../../../../../hooks/status"
import { Status } from "../../../../../../utils/enums"
import { useContextState } from "../../../../../../hooks/theme"

const Section = memo(({ title, amountQuestions, totalPoints, pointsOfUser, questions, description, value, sectionOf, totalSection, statusId }: SectionProps) => {
    const styles = useStyles()
    const { t } = useTranslation()
    const [expand, setExpand] = useState(false)
    const color = useMemo(() => {
        return assignColor(value)
    }, [])
    const { colors } = useContextState()

    const statusLocale = getStatus( statusId ?? Status.ACTIVE, colors, t)

    return (
        <Box sx={styles.container}>
            <Typography sx={styles.header}>{t('general.sectionTo', { section: sectionOf ?? '', total: totalSection ?? '' })}</Typography>
            <Box sx={styles.headerBorder}>
                <CustomAccordion
                    accordionProps={{ sx: styles.accordion }}
                    title={(
                        <Box sx={styles.containerHeader}>
                            <Typography sx={styles.headerTitle}>{title}{description ? ` - ${description}` : ''}</Typography>

                            {expand && <Box sx={styles.borderB} />}

                            <StatusComponent type="noLine" size="big" color={statusLocale.color} msg={statusLocale.text} />
                            {/* <Typography sx={{color: status.color,fontSize: '18px'}}>{status.text}</Typography> */}

                            <Box sx={styles.headerAction}>

                                <Typography><span className="span">{totalPoints}</span> {t('schedule.points')}</Typography>

                                <Typography className="separator"><span className="span">{amountQuestions}</span> {t('schedule.questions')}</Typography>

                                <Typography variant="big" color={color} fontWeight='800' sx={styles.headerValue}>{value}%</Typography>

                                <Typography variant="big" sx={styles.headerActionCounter}>({pointsOfUser}/{totalPoints})</Typography>

                                <IconButton sx={[styles.arrow, styles.rotate(expand)]}>{icons('arrow-down')}</IconButton>
                            </Box>
                        </Box>
                    )}
                    description={(
                        <Box sx={styles.description}>
                            {questions?.map((question, index) => (<Question {...question} position={String(index + 1)} />))}
                        </Box>
                    )}
                    expandIcon={null}
                    onChange={() => { setExpand(!expand) }}
                    expanded={expand}
                />
            </Box>
        </Box>
    )
})

export { Section }